import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { updatePacienteLaboratorio } from "../services/laboratorio.service";

import { successNotification, dangerNotification } from '../../../redux/slices/ui';

export const usePacienteLaboratorioEditar = (id) => {

    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    const updateLaboratorioMutation = useMutation({
        mutationFn: updatePacienteLaboratorio,
        onSuccess: (laboratorio, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ['paciente/laboratorio', id] });
            variables.success();
            dispatch(successNotification('Laboratorio editado'));
        },
        onError: (error, variables, context) => {
            // console.log(error);
            dispatch(dangerNotification(error.message));
        },
    });

    return {
        updateLaboratorioMutation,
    }
}